document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("ContactFooter");
  if (!form) return;
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    console.log("sending request");
    const emailElem = form.querySelector('input[name="contact[email]"]');
    const phoneElem = form.querySelector('input[name="contact[phone]"]');
    const email = emailElem.value.trim();
    const phone = phoneElem.value.trim();
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const phoneValid = /^\+[0-9]{8,15}$/.test(phone);
    const endpoint = "https://klaviyo1-4b5c0605d710.herokuapp.com/";
    const signUpFeedback = document.querySelector(".signup-feedback");
    clearErrors(emailElem, phoneElem);
    if (email == "" && phone == "") {
      showMessage(phoneElem, "Either an email or a phone number must be provided");
      return;
    }

    if (email != "" && !emailValid) {
      showMessage(emailElem, "email invalid");
      return;
    }

    if (phone != "" && !phoneValid) {
      showMessage(
        phoneElem,
        "please enter a valid us phone number including the +1 country code"
      );
      return;
    }

    try {
      signUpFeedback.textContent = "Processing your subscription...";

      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, phone }),
      });

      const data = await response.json();

      if (response.ok) {
        signUpFeedback.textContent = "Thank you for subscribing!";
        form.reset();
      } else {
        console.error("API Error:", data);
        const reason =
          data.reason ||
          data.message ||
          (data.response && data.response.message) ||
          "";

        const match = reason.match(/PHONE_[A-Z_]+/);
        let code = match ? match[0] : null;
        const errorMessages = {
          PHONE_INVALID_NUMBER_FOR_REGION:
            "Please enter a valid U.S. phone number, including the +1 country code.",
          INVALID_PHONE_FORMAT:
            "The phone number format seems incorrect. Please check and try again.",
          EMAIL_INVALID: "Please provide a valid email address.",
        };
        const friendly =
          errorMessages[code] ||
          "We couldn’t complete your subscription. Please verify your information.";

        signUpFeedback.textContent = friendly;
      }
    } catch (err) {
      console.error("Network Error:", err);
      signUpFeedback.textContent = "Unable to connect ";
    }
  });

  function clearErrors(email, phone) {
    document.querySelectorAll(".newsletter-form__message").forEach((elem) => {
      elem.remove();
    });
    email.classList.remove("has-error");
    phone.classList.remove("has-error");
  }
  function showMessage(elem, msg) {
    elem.classList.add("has-error");

    const messageHTML = `
      <small class="newsletter-form__message form__message" id="ContactFooter-error">
        <svg style="background-color:#fff;border-radius:100%;" width="14" height="14"
             viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 2V6" stroke="#E5001F"/>
          <circle cx="5" cy="7.5" r="0.5" fill="#E5001F"/>
        </svg>
        ${msg}
      </small>
    `;

    elem.insertAdjacentHTML("afterend", messageHTML);
  }
});
